module.exports = __webpack_public_path__ + "external-link.svg?6aeb2455d78babcadee80b34a6ba3dd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/external-link.svg
// module id = 147
// module chunks = 2